export default __webpack_public_path__ + "static/media/bubble_nova_xl1.8ffa34a7.png";